export enum FundsStatus {
    Pending = 'pending',
    Received = 'received',
    Allocated = 'allocated',
    PartiallyAllocated = 'partially-allocated',
    MatchSuggested = 'match-suggested',
    Unmatched = 'unmatched',
    Refunded = 'refunded',
}
